import React, { useEffect, useRef, useState } from "react";
import OrderingContainer from "./orderingContainer.js";
export default function OrderingContainerManager(props) {
    const [openedOrderingContainer, setOpenedOrderingContainer] = useState(false);
    const containerProps = useRef(null);
    useEffect(() => {
        props.setFunction((props) => {
            containerProps.current = props;
            setOpenedOrderingContainer(true);
        });
    }, []);
    return (React.createElement(React.Fragment, null, openedOrderingContainer && (React.createElement(OrderingContainer, { ...containerProps.current, onExited: () => setOpenedOrderingContainer(false) }))));
}
